
// import 'core-js'
// import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import 'venuescanner-scss/stylesheets/pages/core.scss'
// import { hideOnScroll } from 'venuescanner-js/vanilla/widgets/navbar'
// import { pageLoaded } from 'venuescanner-js/tools/elemental'
import { lazyload } from 'venuescanner-js/vanilla/widgets/lazyload'

import 'venuescanner-js/vanilla/widgets/cookies.widget'
import 'venuescanner-js/vanilla/widgets/newsletter.widget'
import 'venuescanner-js/vanilla/widgets/shortlist'
import 'venuescanner-js/vanilla/widgets/unread'
import 'venuescanner-js/utils/polyfills'

import 'venuescanner-js/services/models/userFlags'

// require.context('venuescanner-scss/images/nav_icons', false)
// require.context('venuescanner-scss/images/icons', false)
// require.context('venuescanner-scss/images/brands', false)
// console.log('Core loaded')
lazyload.init()
// pageLoaded(() => {
//   hideOnScroll()
// })
